<app-spinner name="employee-overview"></app-spinner>
<div>
  @if (false) {
    <app-alert></app-alert>
  }
</div>

<div>
  <app-multi-org-filter-ta pageType="add-employee-role" [showRequired]="true" [showSelectRoles]="true" [isRoleAdmin]="true"></app-multi-org-filter-ta> 
  <div class="mb-10 mt-20">
    Review the application roles and permissions granted to employees in your organization.
  </div>
  <div class="flex">
    <div class="basis-50">
      <div class="mtb-20">
        <h3>
          Employee Role Overview
        </h3>
      </div>
    </div>
  </div>
  <div class="mtb-20 gap-20 flex" *ngIf="isDewOrg && hasProfileAdmin">
    <div class="lrg flex align-center">
      <input type="checkbox" id="dewStaff" name="dewStaff" [(ngModel)]="isDewStaff" (change)="onDewStaffChange()">
      <label class="ml-10" for="dewStaff">DEW Staff Members</label>
    </div>
  </div>
  <div class="inline-text-field-container even-cols flex-row gap-20">
    <div>
      <div class="flex to-block width-full gap-10">
        <div class="inline-text-field-container flex-row gap-20 mb-20 basis-50">
          <div class="container radio-button radio-bg relative">
            <input id="role" name="rolesystem" type="radio" value="role"
              [(ngModel)]="selectedType">
              <label class="gray-300  click-white" for="role">
                *Find Employee Role Overview
              </label>
            </div>
          </div>
          <div class="inline-text-field-container flex-row gap-20 mb-20 basis-50">
            <div class="container radio-button radio-bg relative">
              <input id="system" name="rolesystem" type="radio" value="system"
                [(ngModel)]="selectedType">
                <label class="gray-300  click-white" for="system">
                  *Find Role Your Employee(s) Have
                </label>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      @if (selectedType === 'role') {
        <div class="border-bottom border-gray-600 mb-20 pb-10">
          <div class="inline-text-field-container even-cols flex-row gap-20">
            <ng-select class="custom" placeholder="*Search Employee" [items]="employees$ | async"
              [typeahead]="search$" [loading]="loading" [clearable]="true"
              [(ngModel)]="selectedEmployeeKey" (change)="onEmployeeSelect($event)" [disabled]="!roleRequestService.isRoleAndOrgSelected()">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '')}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '')}}</span>
              </ng-template>
            </ng-select>
            <div></div>
          </div>
        </div>
        <div class=" mb-30 fade">
          <div class="card fluid ">
            <div class="card__content border-bottom border-gray-600">
              <div class="width-full">
                <div>
                  <div class="mtb-10">
                    <b>Current Roles</b>
                  </div>
                </div>
                <div>
                  @if (userRoles?.length) {
                    <ul class="roles">
                      @for (role  of userRoles; track role ) {
                        <li>
                          {{role.roleName}}
                        </li>
                      }
                    </ul>
                  }
                  @if (!userRoles?.length) {
                    <div class="flex justify-center mt-20">
                      <div class="mtb-20">
                        <b>No roles found</b>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" mb-30 fade">
          <div class="card fluid mb-30">
            <div class="card__content border-bottom border-gray-600">
              <div class="width-full">
                <div class="mtb-10">
                  <b>Role Requests Pending Approval</b>
                </div>
                <!-- this is the desktop view handled by CSS-->
                <div class="mt-10 desktop-view">
                  <div class="overflow-auto">
                    <table class="table-ode">
                      <thead>
                        <tr>
                          <th>Role Name</th>
                          <th>Org Name</th>
                          <th>Request Type</th>
                          <th>Approval Status</th>
                          <th>Approved By</th>
                          <th>Approved Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- *ngFor="let roleReq of roleRequests" -->
                        @for (roleRequest of pendingRequestsData.currentData; track roleRequest) {
                          <tr>
                            <td>{{roleRequest.roleName}}</td>
                            <td>{{roleRequest.orgName}} ({{roleRequest.orgIrn}})</td>
                            <td>{{ roleRequest.roleRequestType}}</td>
                            <td> {{addSpacesAtCapitals(roleRequest.workflowStateName)}}</td>
                            <td> {{roleRequest.updatedBy}}</td>
                            <td> {{roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a'}}</td>
                          </tr>
                        }
                        @if (!pendingRequestsData?.currentData?.length) {
                          <tr>
                            <td colspan="5" class="text-center bold">No role requests found</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    @if (pendingRequestsData?.currentData?.length > 0) {
                      <div class="row">
                        <div class="paginator-adjust">
                          <eas-ui-lib-paginator [currentPage]="pendingRequestsData.currentPage" [pageSize]="pendingRequestsData.pageSize" [totalSize]="pendingRequestsData.pendingRequests.length"
                          (pageChanged)="onPendingRequestsPageChanged($event)"></eas-ui-lib-paginator>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <!-- End this is the desktop view handled by CSS-->
                <!-- This is mobile view handled by CSS -->
                <div class="mt-10 mobile-view">
                  <!-- this is one row -->
                  @for (roleRequest of pendingRequestsData.pendingRequests; track roleRequest) {
                    <ul class="info pb-10 mb-20">
                      <li>
                        <div>
                          Role Name
                        </div>
                        <div class="bold">
                          {{roleRequest.roleKey}}
                        </div>
                      </li>
                      <li>
                        <div>
                          Org Name
                        </div>
                        <div class="bold">
                          {{roleRequest.orgKey}} ( {{roleRequest.orgIrn}})
                        </div>
                      </li>
                      <li>
                        <div>Request Type</div>
                        <div class="bold">{{ roleRequest.roleRequestType }}</div>
                      </li>
                      <li>
                        <div>
                          Approval Status
                        </div>
                        <div class="bold">
                          {{roleRequest.workflowStateKey}}
                        </div>
                      </li>
                      <li>
                        <div>
                          Approved By
                        </div>
                        <div class="bold">
                          {{roleRequest.updatePersonKey}}
                        </div>
                      </li>
                      <li>
                        <div>
                          Approved Date
                        </div>
                        <div class="bold">
                          {{roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a'}}
                        </div>
                      </li>
                    </ul>
                  }
                  <!--End this is one row -->
                </div>
                <!--End This is mobile view handled by CSS -->
              </div>
            </div>
          </div>
        </div>
        <div class="mb-30 fade">
          <div class="card fluid mb-30">
            <div class="card__content border-bottom border-gray-600">
              <div class="width-full">
                <div class="mtb-10">
                  <b>Role Request History</b>
                </div>
                <!-- this is the desktop view handled by CSS-->
                <div class="mt-10 desktop-view">
                  <div class="overflow-auto">
                    <table class="table-ode">
                      <thead>
                        <tr>
                          <th>Role Name</th>
                          <th>Org Name</th>
                          <th>Request Type</th>
                          <th>Role Change Status</th>
                          <th>Changed By</th>
                          <th>Change Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let roleRequest of roleRequestsData.currentData">
                          <td>{{roleRequest.roleName}}</td>
                          <td> {{roleRequest.orgName}} ({{roleRequest.orgIrn}})</td>
                          <td>{{ roleRequest.roleRequestType}}</td>
                          <td> {{addSpacesAtCapitals(roleRequest.workflowStateName)}}</td>
                          <td> {{roleRequest.updatedBy}}</td>
                          <td> {{roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a'}}</td>
                      </tr>
                        @if (!roleRequestsData?.currentData?.length) {
                          <tr>
                            <td colspan="5" class="text-center"><strong>No role history found</strong></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    @if (roleRequestsData?.currentData?.length > 0) {
                      <div class="row">
                        <div class="paginator-adjust">
                          <eas-ui-lib-paginator [currentPage]="roleRequestsData.currentPage" [pageSize]="roleRequestsData.pageSize" [totalSize]="roleRequestsData.roleRequests.length"
                          (pageChanged)="onRoleRequestPageChanged($event)"></eas-ui-lib-paginator>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <!-- End this is the desktop view handled by CSS-->
                <!-- This is mobile view handled by CSS -->
                <div class="mt-10 mobile-view">
                  <!-- this is one row -->
                  @if (false) {
                    <ul class="info-history pb-10 mb-20">
                      <li>
                        <div>
                          Role Name
                        </div>
                        <div class="bold">
                          Coord-Title 2 Programs
                        </div>
                      </li>
                      <li>
                        <div>
                          Org Name
                        </div>
                        <div class="bold">
                          Arlington Elementary School (000968)
                        </div>
                      </li>
                      <li>
                        <div>
                          Role Change Status
                        </div>
                        <div class="bold">
                          Submitted
                        </div>
                      </li>
                      <li>
                        <div>
                          Changed By
                        </div>
                        <div class="bold">
                          NA
                        </div>
                      </li>
                      <li>
                        <div>
                          Change Date
                        </div>
                        <div class="bold">
                          02/14/2024
                        </div>
                      </li>
                    </ul>
                  }
                  <!--End this is one row -->
                </div>
                <!--End This is mobile view handled by CSS -->
              </div>
            </div>
          </div>
        </div>
      }
      @if (selectedType === 'system') {
        <div class="border-bottom border-gray-600 mb-20 pb-10">
          <div class="inline-text-field-container even-cols flex-row gap-20">
            <ng-select class="custom" (change)="onRoleSelect($event?.roleKey)" style="width: 50%;" [disabled]="!roleRequestService.isRoleAndOrgSelected()"
              placeholder="*Select Role" [items]="dropdowns.userRoles" bindLabel="applicationRoleName" [(ngModel)]="selectedRole">
              <ng-template ng-multi-label-tmp let-items="items">
                <div class="ng-value">
                  <span class="ng-value-label">*Select Role</span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <span class="ng-value-label">{{item.applicationRoleName}}</span>
              </ng-template>
            </ng-select>
            <div></div>
          </div>
        </div>
        <div class=" mb-30 fade">
          <div class="card fluid ">
            <div class="card__content border-bottom border-gray-600">
              <div class="width-full">
                <div>
                  <div class="mtb-10">
                    <span>
                      <strong>Role</strong>:
                    </span>
                    <span>
                      <b>{{selectedRole?.applicationRoleName}}</b>
                    </span>
                    <div class="mt-5">
                      List of people who have this role associated to them.
                    </div>
                  </div>
                </div>
                <div>
                  <ul class="roles manager">
                    @for (employee of employeesList; track employee) {
                      <li>
                        <a (click)="selectEmployee(employee)">
                          {{employee.person.firstName + " " + employee.person.lastName}}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="container flex border-top border-gray-600 mt-20 pt-10">
        <span class="basis-50">
          <span class="flex justify-start">
            <button [routerLink]="['..']"
              class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
              <div class="btn-txt font-red bold">Back</div>
            </button>
          </span>
        </span>
        <span class="basis-50">
        </span>
      </div>

    </div>